import { render, staticRenderFns } from "./SuppliersBookingSettingsForm.vue?vue&type=template&id=168e6e1c&"
import script from "./SuppliersBookingSettingsForm.vue?vue&type=script&lang=js&"
export * from "./SuppliersBookingSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports